<p-drawer
  [(visible)]="isVisible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  styleClass="filters-sidebar"
  [style]="{ width: '420px' }"
  (onHide)="onSidebarHide()">
  <ng-template pTemplate="header">
    <div class="sidebar-header">
      <div class="header-left">
        <i class="pi pi-filter"></i>
        <span class="font-bold">Filtros</span>
      </div>
    </div>
  </ng-template>

  <form [formGroup]="filterForm" appAutoFormGroup>
    <div class="filter-content">
      <p class="filter-hint">
        Marque quantos quiser em cada filtro: valores do mesmo filtro somam, filtros diferentes
        restringem.
      </p>

      <div class="mt-4">
        <label class="field-group-label">Período</label>
        <div class="field-group">
          <div class="field-half">
            <app-calendar label="De" placeholder="Data inicial" [controlName]="'from'" />
          </div>
          <div class="field-half">
            <app-calendar label="Até" placeholder="Data final" [controlName]="'to'" />
          </div>
        </div>
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'companyIds'"
          [label]="'Empresas'"
          [placeholder]="'Todas as empresas'"
          [emptyMessage]="'Nenhuma empresa em reuniões ainda.'"
          [options]="companyOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'partnerIds'"
          [label]="'Parceiros'"
          [placeholder]="'Todos os parceiros'"
          [emptyMessage]="'Nenhum parceiro em reuniões ainda.'"
          [options]="partnerOptions" />
      </div>

      <div class="mt-4">
        <app-select-financial-institution
          [multiple]="true"
          [controlName]="'financialInstitutionIds'"
          [label]="'Bancos'"
          [placeholder]="'Todos os bancos'"
          [emptyMessage]="'Nenhum banco em reuniões ainda.'"
          [lazyLoad]="true"
          [options]="bankOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'dealIds'"
          [label]="'Deals'"
          [placeholder]="'Todos os deals'"
          [emptyMessage]="'Nenhum deal vinculado a reuniões ainda.'"
          [options]="dealOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'statuses'"
          [label]="'Situações'"
          [placeholder]="'Todas as situações'"
          [options]="statusOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'callTypes'"
          [label]="'Tipo da reunião'"
          [placeholder]="'Todos os tipos'"
          [options]="callTypeOptions" />
      </div>

      <!-- Card 3803: o mesmo filtro das pílulas "Para o cliente" acima da lista. -->
      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'clientVisibility'"
          [label]="'Para o cliente'"
          [placeholder]="'Todas'"
          [options]="clientVisibilityOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'sources'"
          [label]="'Origem do bot'"
          [placeholder]="'Agenda e manual'"
          [options]="sourceOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'organizerUserIds'"
          [label]="'Organizadores'"
          [placeholder]="'Todos os organizadores'"
          [emptyMessage]="'Nenhum organizador ainda.'"
          [options]="organizerOptions" />
      </div>

      <div class="mt-4">
        <app-select
          [multiple]="true"
          [controlName]="'participantEmails'"
          [label]="'Participantes'"
          [placeholder]="'Todos os participantes'"
          [emptyMessage]="'Nenhum participante com e-mail ainda.'"
          [options]="participantOptions" />
        <div class="mt-2">
          <app-checkbox
            [checkbox]="attendedOnlyCheckbox"
            [controlName]="'participantAttendedOnly'" />
        </div>
      </div>

      <div class="mt-4">
        <div class="field-group">
          <div class="field-half">
            <app-select
              [allowEmptyPlaceholderSelect]="true"
              [controlName]="'hasRecording'"
              [label]="'Com gravação'"
              [placeholder]="'Tanto faz'"
              [options]="simNaoOptions" />
          </div>
          <div class="field-half">
            <app-select
              [allowEmptyPlaceholderSelect]="true"
              [controlName]="'hasTranscript'"
              [label]="'Com transcrição'"
              [placeholder]="'Tanto faz'"
              [options]="simNaoOptions" />
          </div>
        </div>
      </div>

      <div class="mt-4">
        <app-checkbox [checkbox]="onlyUnlinkedCheckbox" [controlName]="'onlyUnlinked'" />
      </div>
    </div>

    <div class="filter-actions d-flex justify-content-between align-items-center">
      <app-button [label]="'Limpar'" type="button" (sendButtonClick)="clear()" theme="white" />
      <app-button [label]="'Aplicar filtros'" type="button" (sendButtonClick)="submit()" />
    </div>
  </form>
</p-drawer>
